import { Data } from 'signup-constants/signupData/Data';
import { UseCase } from 'signup-constants/signupData/UseCaseOption';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { DataOptions } from '../signup-data/signupDataOptions';
import { useSignupData } from '../signup-data/useSignupData';
import { BaseButtonsView } from './BaseButtonsView';
import { jsx as _jsx } from "react/jsx-runtime";
export const isUseCaseButtonDisabled = (data, key) => {
  return data.split(',').length === 3 && !data.includes(key);
};
export const getUseCaseDataWithoutKey = (useCaseData, key) => {
  const useCaseList = useCaseData.split(',');
  const useCaseListWithoutSelectedKey = useCaseList.filter(useCaseKey => useCaseKey !== key);
  const filteredData = useCaseListWithoutSelectedKey.join(',');
  return filteredData;
};
const UseCaseView = () => {
  const dataKey = Data.UseCase;
  const {
    isMobile
  } = useResponsiveness();
  const options = DataOptions[dataKey];
  const {
    data
  } = useSignupData(dataKey);
  const isSelected = key => {
    return data.includes(key);
  };
  const setDataFn = (key, setData) => {
    let useCaseData = data;
    if (isSelected(key)) {
      useCaseData = getUseCaseDataWithoutKey(useCaseData, key);
    } else if (key === UseCase.StillExploring) {
      useCaseData = UseCase.StillExploring;
    } else {
      useCaseData = getUseCaseDataWithoutKey(useCaseData, UseCase.StillExploring);
      useCaseData = useCaseData ? useCaseData.concat(`,${key}`) : key;
    }
    setData(useCaseData);
  };
  return /*#__PURE__*/_jsx(BaseButtonsView, {
    columnCount: isMobile ? 1 : 2,
    hasNextButton: true,
    isSelected: isSelected,
    options: options,
    setDataFn: setDataFn,
    shouldDisableAutofocus: true,
    type: "checkbox"
  });
};
export default UseCaseView;